import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

import { attributesNames } from '../../../../constants'
// import { Logger, LoggerTypes } from '../../../../utils'
import { AttributeToolsHeader } from '../../AttributeToolsHeader'
import { AttributeParameterDialogCreate } from '../dialogs'
import { AttributeParameterCard } from '../AttributeParameterCard'

export const AttributeParameterPanel = ({
  parameters,
  currentProject,
  currentScenario,
  terms,
  openDialog,
  setOpenDialog,
  onSearch,
  onAdd,
  onUpdate,
  onImport,
  onDelete,
  onCreate
}) => {
  // Logger.trace(LoggerTypes.CONTAINER, 'AttributeParameterPanel.render()', {
  //   currentProject,
  //   currentScenario,
  //   parameters,
  //   terms
  // })

  const TAB_PANEL_HEIGHT = `${$(window).height() - 330}px`

  return (
    <div className="AttributeParameterPanel">
      <AttributeToolsHeader
        currentProject={currentProject}
        currentScenario={currentScenario}
        attributeName={attributesNames.PARAMETERS}
        terms={terms}
        onSearch={onSearch}
        onAdd={onAdd}
        onImport={onImport}
      />
      <div className="attributes-list" style={{ overflow: 'hidden auto', marginTop: '53px', height: TAB_PANEL_HEIGHT }}>
        {parameters &&
          parameters.map((parameter, index) => (
            <AttributeParameterCard
              key={`parameter-${index}`}
              parameters={parameters}
              parameter={parameter}
              currentProject={currentProject}
              currentScenario={currentScenario}
              actionDispatchDelete={onDelete}
              actionDispatchUpdate={onUpdate}
            />
          ))}
      </div>
      {openDialog && (
        <AttributeParameterDialogCreate
          actionCreateDispatch={onCreate}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          currentProject={currentProject}
          currentScenario={currentScenario}
          parameters={parameters}
        />
      )}
    </div>
  )
}

AttributeParameterPanel.displayName = 'AttributeParameterPanel'

AttributeParameterPanel.propTypes = {
  parameters: PropTypes.array.isRequired,
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  terms: PropTypes.string.isRequired,
  onSearch: PropTypes.func,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onCreate: PropTypes.func,
  onImport: PropTypes.func
}

AttributeParameterPanel.defaultProps = {
  parameters: [],
  currentProject: null,
  currentScenario: null,
  terms: '',
  openDialog: false,
  setOpenDialog: () => {},
  onSearch: null,
  onAdd: null,
  onUpdate: null,
  onDelete: null,
  onCreate: null,
  onImport: null
}
